import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  section: {
    marginBottom: '7.2rem',
  },
  sectionTitle: {
    font: {
      size: '1.8rem',
      lineHeight: '2.4rem',
      weight: 700,
    },
    letterSpacing: '0.1rem',
    color: colors.neutral[700],
    textTransform: 'uppercase',
    margin: '0 0 1.6rem 0',
  },
  proposalsCardWrapper: { position: 'relative' },
  proposalDetailsRecord: { marginBottom: '0.2rem', display: 'flex' },
  proposalDetailKey: {
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 400 },
    letterSpacing: '0.02rem',
    color: colors.neutral[700],
    paddingRight: '2rem',
    width: '13.2rem',
  },
  productLineValue: {
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 700 },
    letterSpacing: '0.02rem',
    color: colors.neutral[700],
    maxWidth: '48rem',
  },
  proposalDetailsSection: { listStyle: 'none', padding: 0, margin: 0 },
};
const createStyles = createUseStyles(styles);
export { createStyles };
